import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import theme from '../../config/theme';
import DoctorHeader from '../../layouts/doctor/DoctorHeader';
import DoctorSidebar from '../../layouts/doctor/DoctorSidebar';
import { Outlet } from 'react-router-dom';
import { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from "axios";
import path from '../../path';
import useEncryption from '../../services/useEncryption';
import "./stylesDoctor.css"
import Loader from '../../helpers/loader/Loader';

function DoctorDashboard() {
  const [isOpen, setIsOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const {id} =useParams();
  const {decryptData } = useEncryption();
  
  return (
    <React.Fragment>
     
      <ThemeProvider theme={theme} >
          <CssBaseline />
          <Loader loading={loading} />
          <Box sx={styles.container} className="mainConatiner">
              <DoctorSidebar isOpen={isOpen} />
              <Box component="main" sx={styles.mainSection}>
                <Outlet context={[loading, setLoading]}/>
              </Box>
          </Box>
      </ThemeProvider>  
    </React.Fragment>
  );
}

/** @type {import("@mui/material").SxProps} */
const styles = {
  container:{
    display:'flex',
    bcolor:'neutral-light',
    height:'calc(100%-64px)'
  },
  mainSection:{
    p:4,
    width:'100%',
    height:'100%',
    overflow:'auto'
  }

}

export default DoctorDashboard;
